import options from './chart-range-selector.component';

export default {
    selector: 'dtChartRangeSelector',
    options
};
